module.exports = __webpack_public_path__ + "static/media/model1.05a40b30.mp4";